import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';

const PrismicTextContent = props => <>{RichText.asText(props.content)}</>;

PrismicTextContent.propTypes = {
  content: PropTypes.any,
};

export default PrismicTextContent;
